import React, { Component } from 'react';
import SVG from 'react-inlinesvg';
import { assetUrl } from '~/src/config/routes.js';
import t from '~/src/services/i18n';
import routes from '~/src/config/routes.js';
import './Footer.scss';

const contacts = [
  {name: 'facebook', path: 'https://www.facebook.com/Cloudinary', icon: 'Icons/facebook.svg'},
  {name: 'twitter', path: 'https://twitter.com/cloudinary', icon: 'Icons/twitter.svg'},
  {name: 'linkedin', path: 'https://linkedin.com/company/cloudinary', icon: 'Icons/linkedin.svg'},
];

class Footer extends Component {
  render() {
    return (
      <div className="footer">
        <a href="https://cloudinary.com/" className="footer-logo">
          <img
            src={assetUrl('cloudinary_logo_for_black_bg.svg')}
            alt="Cloudinary Logo"
            width="170"
          />
        </a>
        <div className="footer-links">
          <a href={routes.tos}>
            {t('termsOfUse')}
          </a>
          <a href={routes.privacy}>
            {t('privacyPolicy')}
          </a>
          <a href={routes.documentation}>
            {t('documentation')}
          </a>
        </div>
        <div className="contact-us">
          {t('contactUs')}
          <div className="contacts">
            {contacts.map((contact) =>
              <a href={contact.path} key={contact.name}>
                <SVG src={assetUrl(contact.icon)} />
              </a>
            )}
          </div>
        </div>
        <a href="https://cloudinary.com/users/login" className="sign-up btn btn-small btn-primary">
          {t('signUp')}
        </a>
        <p className="rights">
          {String.fromCharCode(169)} {t('cloudinaryRights')}
        </p>
      </div>
    );
  }
}

export default Footer;
